import { FC, SVGProps } from "react";
import "./index.css";

const PostBookLoaderIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      viewBox="0 0 200 140"
      role="img"
      {...props}
    >
      <title>Hotel to plane loader</title>
    
      <g className="hotel">
        <g transform="translate(20 -4)" className="s">
          <g className="ground">
            <path d="M30 118H120" />
          </g>
          <g className="body">
            <rect x="45" y="30" width="70" height="88" rx="1.5" />
          </g>
          <g className="roof">
            <rect x="53" y="18" width="54" height="12" rx="1" />
            <circle className="dot" cx="88" cy="24" r="1.2" />
            <path d="M93 24H101" />
          </g>
          <g className="windows">
            <rect x="53.5" y="40" width="11" height="8" rx="1" />
            <rect x="74.5" y="40" width="11" height="8" rx="1" />
            <rect x="95.5" y="40" width="11" height="8" rx="1" />
            <rect x="53.5" y="58" width="11" height="8" rx="1" />
            <rect x="74.5" y="58" width="11" height="8" rx="1" />
            <rect x="95.5" y="58" width="11" height="8" rx="1" />
            <rect x="53.5" y="76" width="11" height="8" rx="1" />
            <rect x="74.5" y="76" width="11" height="8" rx="1" />
            <rect x="95.5" y="76" width="11" height="8" rx="1" />
          </g>
          <g className="door">
            <path d="M71 118V95H89V118" />
          </g>
          <g className="tree">
            <ellipse className="bgf" cx="40" cy="88" rx="13" ry="16" />
            <path d="M40 104V118" />
            <path d="M40 100V81M40 92L34.5 86.5M40 87L45 82" />
          </g>
          <g className="bush">
            <path
              className="bgf"
              d="M106.4 118H130.6A5.4 5.4 0 0 0 130.6 107.2L125.57 107.2A9 9 0 0 0 107.93 107.2L106.4 107.2A5.4 5.4 0 0 0 106.4 118Z"
            />
          </g>
          <g className="hcloud">
            <path
              className="bgf"
              d="M44.2 22H64.8A4.2 4.2 0 0 0 64.8 13.6L59.91 13.6A7 7 0 0 0 46.19 13.6L44.2 13.6A4.2 4.2 0 0 0 44.2 22Z"
            />
          </g>
        </g>
      </g>
      <g className="pfloat">
        <g className="pfade s">
          <g className="wing">
            <g transform="translate(100 70) scale(.27) translate(-253 -208.5)" style={{ strokeWidth: "7.407px" }}>
              <path d="M222 183L172 131Q166 125 176 127H218Q224 127 232 133L297 183" />
            </g>
          </g>
          <g className="fuselage">
            <g transform="translate(100 70) scale(.27) translate(-253 -208.5)" style={{ strokeWidth: "7.407px" }}>
              <path d="M76 157H98C108 157 115 165 128 178L135 183H402C420 183 430 195 436 212C440 228 428 234 418 234H318C312 234 306 237 300 241L232 300Q226 305 218 303H176Q166 302 172 294L222 236Q224 234 228 234H122Q112 234 106 224L68 163Q66 157 76 157Z" />
            </g>
          </g>
          <g className="details">
            <g transform="translate(100 70) scale(.27) translate(-253 -208.5)" style={{ strokeWidth: "7.407px" }}>
              <path d="M94 202H134" />
              <circle className="dot" cx="151" cy="203" r="3" />
              <path d="M342 201H386M402 201H414" />
            </g>
          </g>
          <g className="pcloud1">
            <path d="M152.7 51H162.3A2.7 2.7 0 0 0 162.3 45.6L161.16 45.6A4.5 4.5 0 0 0 152.34 45.6L152.7 45.6A2.7 2.7 0 0 0 152.7 51Z" />
          </g>
          <g className="pcloud2">
            <path d="M122.9 107H137.1A3.9 3.9 0 0 0 137.1 99.2L135.27 99.2A6.5 6.5 0 0 0 122.53 99.2L122.9 99.2A3.9 3.9 0 0 0 122.9 107Z" />
          </g>
          <g className="lineA">
            <path d="M52 47.5H72" />
          </g>
          <g className="lineB">
            <path d="M44 47.5H49" />
          </g>
          <g className="lineC">
            <path d="M50 98H70" />
          </g>
          <g className="lineD">
            <path d="M78 98H80" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default PostBookLoaderIcon;
